import * as Styled from './FilterItemStyles';

export interface FilterItemStandardProps {
  e: any,
  filterName?: any,
  onSelect: Function,
  isActive: boolean,
}

const FilterItem = ({e, onSelect, isActive}:FilterItemStandardProps) => {
  const isIcon = !!e.icon;
  const className = `${isIcon && 'FilterIcon'} ${isActive && 'ChosenFilter'}`

  return (
    <Styled.StyledSpan
      className={className}
      onClick={()=>onSelect(e)}
    >
      {e.icon ?
        <Styled.Icon src={e.icon.default} /> :
        e.name
      }
    </Styled.StyledSpan>
  );
}

export default FilterItem;